module.exports = __webpack_public_path__ + "img/seedselector.1c7a94c9.png";